const LeftIconButton = ({ text, btnStyle, Icon, iconStyle, onClick,size }) => {
  return (
    <button
      onClick={onClick}
      className={`${btnStyle} flex items-center relative px-3 py-1 rounded transition-all ease-in-out duration-300 font-figtree 2xs:max-md:text-xs 2xs:max-md:px-1 2xs:max-md:py-1`}
    >
      <Icon size={size} className={`${iconStyle}`} />
      <span className="pl-[2px]">{text}</span>
    </button>
  );
};

export default LeftIconButton;
